const doc = { content: "block+" };

export default doc;
